import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Config from 'config';
import TimelineItem from 'layouts/Timeline/TimelineItem';
import { dateTimeFormat } from 'common';

const ShowTrackShipmentPopup = (props) => {
    const { showTrackShipmentDetails, setShowTrackShipmentDetails, t, trackShipmentDetails } = props;
    const BASE = Config.BASE;
    const TOKEN = window.localStorage.getItem('token');
    const scans = trackShipmentDetails ? trackShipmentDetails.Shipment.Scans : [];
    const pickUpDate = dateTimeFormat(trackShipmentDetails.Shipment.PickUpDate)
    const destination = trackShipmentDetails.Shipment.Destination;
    const recievedDate = dateTimeFormat(trackShipmentDetails.Shipment.DestRecieveDate);
    const status = trackShipmentDetails.Shipment.Status.Status;

    const handleShowTrackShipmentClose = () => { setShowTrackShipmentDetails(false) }

    return (
        <Dialog open={showTrackShipmentDetails} onClose={handleShowTrackShipmentClose}>
            <DialogTitle>{t('orderDetails')}</DialogTitle>
            <DialogContent>
                <Grid item xs={12} md={12} lg={12}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {pickUpDate ?
                                    <MDTypography component="p" variant="body2" color="text">
                                        {t('pickUpDate')}  : <b>{pickUpDate}</b>
                                    </MDTypography>
                                    :
                                    null}
                                <MDTypography component="p" variant="body2" fontWeight="regular" color="text">
                                    {t('destination')}  :<b> {destination}</b>
                                </MDTypography>
                                {recievedDate ?
                                    <MDTypography component="p" variant="body2" fontWeight="regular" color="text">
                                        {t('recievedDate')}  : <b>{recievedDate}</b>
                                    </MDTypography>
                                    :
                                    null}
                                <MDTypography component="p" variant="body2" fontWeight="regular" color="text">
                                    {t('status')}  : <b>{status}</b>
                                </MDTypography>
                            </Grid>
                            <Grid item xs={12}>
                                <MDTypography variant="h6" fontWeight="medium">{t('trackOrder')}</MDTypography>
                                {(scans.length > 0) ?
                                    <MDBox mt={2}>
                                        {scans.map((scan, index) => (
                                            <TimelineItem
                                                key={index}
                                                color="info"
                                                icon="done"
                                                title={scan.ScanDetail.Instructions}
                                                location={scan.ScanDetail.ScannedLocation}
                                                dateTime={dateTimeFormat(scan.ScanDetail.ScanDateTime)}
                                                lastItem={(index + 1 == scans.length) ? true : false}
                                            />
                                        ))}
                                    </MDBox>
                                    :
                                    null}
                            </Grid>
                            <Grid item xs={12}>
                                <DialogActions>
                                    <MDButton onClick={handleShowTrackShipmentClose} disableRipple>{t('ok')}</MDButton>
                                </DialogActions>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default ShowTrackShipmentPopup;
